import React from 'react'
import ReactQuill from 'react-quill'
import PropTypes from 'prop-types'


const Wysiwyg = props => {
    return (
        <React.Fragment>
            <ReactQuill
                theme="snow"
                onChange={props.onChange}
                value={props.value}
                placeholder={props.placeholder}
                modules={Wysiwyg.modules}
                formats={Wysiwyg.formats}
            />
        </React.Fragment>
    )
}

export default Wysiwyg

Wysiwyg.modules = {
    toolbar: [
        [{ "header": [1, 2, 3, 4, 5, 6] }],
        [{ 'font': [] }],
        [{ size: ["small", false, "large", "huge"] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ "script": "sub" }, { "script": "super" }], // superscript/subscript
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' },
        { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image', 'video', 'code'],
        ['clean']
    ],
    clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false,
    }
}

Wysiwyg.formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'align',
    'script',
    'list', 'bullet', 'indent',
    'link', 'image', 'video', 'code'
]

Wysiwyg.propTypes = {
    placeholder: PropTypes.string,
}